import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button } from '@vodafoneis/sjonvarpskjarni-js-lib';
import { CHROMECAST_EVENTS } from '../../../../models/THEOPlayer';
import { PlaybackInformationContext } from '../../../../contexts/PlaybackInformationContext';
import { CastState } from '../../../../models/CastState';

const { STATE_CHANGE } = CHROMECAST_EVENTS;
const { UNAVAILABLE } = CastState;

export const PlaybackSettingsCast: React.FC = () => {
	const { player } = useContext(PlaybackInformationContext);

	const [chromecastState, setChromecastState] = useState(player?.getChromecastState() ?? UNAVAILABLE);

	useEffect(() => {
		setChromecastState(player?.getChromecastState() ?? UNAVAILABLE);

		const onChromecastStateChanged = ({ state }) => {
			setChromecastState(state);
		};

		player.addChromecastListener(STATE_CHANGE, onChromecastStateChanged);

		return () => {
			if (player) {
				player.removeChromecastListener(STATE_CHANGE, onChromecastStateChanged);
			}
		};
	}, [player]);

	const onChromecastButtonPressed = useCallback(
		(event) => {
			event.preventDefault();
			event.stopPropagation();

			if (!player.isCasting()) {
				player.startChromecast();
			} else {
				player.stopChromecast();
			}
		},
		[player]
	);

	if (!chromecastState || chromecastState === UNAVAILABLE) return null;

	return <Button className={`playback-settings-cast playback-settings-cast-${chromecastState}`} onClick={onChromecastButtonPressed} />;
};
